export default __webpack_public_path__ + "static/media/grav.0f5b0806.svg";